var nmaps = {
  isub: {
    99: [99],
    100: [100],
    102: [102],
    103: [103],
    113: [113],
    119: [119],
    121: [121],
    122: [122],
    7522: [105],
    7523: [114],
    7524: [117],
    7525: [118],
    8337: [101],
    8338: [111],
    8339: [120],
    8341: [104],
    8342: [107],
    8343: [108],
    8344: [109],
    8345: [110],
    8346: [112],
    8347: [115],
    8348: [116],
    11388: [106],
  },
  isc: {
    115: [115],
    120: [120],
    491: [113],
    610: [103],
    618: [105],
    628: [110],
    640: [114],
    655: [121],
    665: [98],
    668: [104],
    671: [108],
    1171: [102],
    7424: [97],
    7428: [99],
    7429: [100],
    7431: [101],
    7434: [106],
    7435: [107],
    7437: [109],
    7439: [111],
    7448: [112],
    7451: [116],
    7452: [117],
    7456: [118],
    7457: [119],
    7458: [122],
    42800: [102],
  },
  sub: {
    99: [99],
    100: [100],
    101: [8337],
    102: [102],
    103: [103],
    104: [8341],
    105: [7522],
    106: [11388],
    107: [8342],
    108: [8343],
    109: [8344],
    110: [8345],
    111: [8338],
    112: [8346],
    113: [113],
    114: [7523],
    115: [8347],
    116: [8348],
    117: [7524],
    118: [7525],
    119: [119],
    120: [8339],
    121: [121],
    122: [122],
  },
  cu: {
    66: [8492],
    69: [8496],
    70: [8497],
    72: [8459],
    73: [8464],
    76: [8466],
    77: [8499],
    82: [8475],
    101: [8495],
    103: [8458],
    111: [8500],
  },
  icu: {
    8458: [103],
    8459: [72],
    8464: [73],
    8466: [76],
    8475: [82],
    8492: [66],
    8495: [101],
    8496: [69],
    8497: [70],
    8499: [77],
    8500: [111],
  },
  scf: {
    97: [7424],
    98: [665],
    99: [7428],
    100: [7429],
    101: [7431],
    102: [1171],
    103: [610],
    104: [668],
    105: [618],
    106: [7434],
    107: [7435],
    108: [671],
    109: [7437],
    110: [628],
    111: [7439],
    112: [7448],
    113: [491],
    114: [640],
    115: [115],
    116: [7451],
    117: [7452],
    118: [7456],
    119: [7457],
    120: [120],
    121: [655],
    122: [7458],
  },
  sc: {
    97: [7424],
    98: [665],
    99: [7428],
    100: [7429],
    101: [7431],
    102: [42800],
    103: [610],
    104: [668],
    105: [618],
    106: [7434],
    107: [7435],
    108: [671],
    109: [7437],
    110: [628],
    111: [7439],
    112: [7448],
    113: [491],
    114: [640],
    115: [115],
    116: [7451],
    117: [7452],
    118: [7456],
    119: [7457],
    120: [120],
    121: [655],
    122: [7458],
  },
  ifspec: {
    161: [33],
    191: [63],
    305: [105],
    383: [74],
    387: [103],
    398: [69],
    477: [101],
    592: [97],
    596: [99],
    607: [102],
    613: [104],
    623: [109],
    633: [114],
    638: [106],
    647: [116],
    652: [118],
    653: [119],
    654: [121],
    670: [107],
    729: [46],
    741: [76],
    923: [86],
    1021: [67],
    1280: [80],
    1503: [108],
    1563: [59],
    5601: [68],
    7450: [82],
    8009: [81],
    8222: [34],
    8254: [95],
    8256: [8255],
    8262: [8261],
    8498: [70],
    8704: [65],
    8745: [85],
    8757: [8756],
    8869: [84],
  },
  freg: {
    72: [72],
    73: [73],
    77: [87],
    78: [78],
    79: [79],
    83: [83],
    87: [77],
    88: [88],
    90: [90],
    98: [113],
    100: [112],
    110: [117],
    112: [100],
    113: [98],
    117: [110],
  },
  fspec: {
    41: [40],
    44: [39],
    62: [60],
    93: [91],
    125: [123],
    33: [161],
    34: [8222],
    39: [44],
    40: [41],
    46: [729],
    59: [1563],
    60: [62],
    63: [191],
    65: [8704],
    66: [113],
    67: [1021],
    68: [5601],
    69: [398],
    70: [8498],
    71: [387],
    74: [383],
    75: [670],
    76: [741],
    80: [1280],
    81: [8009],
    82: [7450],
    84: [8869],
    85: [8745],
    86: [923],
    89: [654],
    91: [93],
    95: [8254],
    97: [592],
    99: [596],
    101: [477],
    102: [607],
    103: [387],
    104: [613],
    105: [305],
    106: [638],
    107: [670],
    108: [1503],
    109: [623],
    114: [633],
    116: [647],
    118: [652],
    119: [653],
    121: [654],
    123: [125],
    8255: [8256],
    8261: [8262],
    8756: [8757],
  },
  d: {
    97: [867],
    99: [872],
    100: [873],
    101: [868],
    104: [874],
    105: [869],
    109: [875],
    111: [870],
    114: [876],
    116: [877],
    117: [871],
    118: [878],
    120: [879],
  },
  s: {
    40: [8317],
    41: [8318],
    43: [8314],
    45: [8315],
    48: [8304],
    49: [185],
    50: [178],
    51: [179],
    52: [8308],
    53: [8309],
    54: [8310],
    55: [8311],
    56: [8312],
    57: [8313],
    61: [8316],
    65: [7468],
    66: [7470],
    67: [7580],
    68: [7472],
    69: [7473],
    70: [7584],
    71: [7475],
    72: [7476],
    73: [7477],
    74: [7478],
    75: [7479],
    76: [7480],
    77: [7481],
    78: [7482],
    79: [7484],
    80: [7486],
    81: [81],
    82: [7487],
    83: [738],
    84: [7488],
    85: [7489],
    86: [11389],
    87: [7490],
    88: [739],
    89: [696],
    90: [7611],
    97: [7491],
    98: [7495],
    99: [7580],
    100: [7496],
    101: [7497],
    102: [7584],
    103: [7501],
    104: [688],
    105: [7590],
    106: [690],
    107: [7503],
    108: [737],
    109: [7504],
    110: [8319],
    111: [7506],
    112: [7510],
    113: [5227],
    114: [691],
    115: [738],
    116: [7511],
    117: [7512],
    118: [7515],
    119: [695],
    120: [739],
    121: [696],
    122: [7611],
  },
  id: {
    867: [97],
    868: [101],
    869: [105],
    870: [111],
    871: [117],
    872: [99],
    873: [100],
    874: [104],
    875: [109],
    876: [114],
    877: [116],
    878: [118],
    879: [120],
  },
  is: {
    81: [81],
    178: [50],
    179: [51],
    185: [49],
    688: [104],
    690: [106],
    691: [114],
    695: [119],
    696: [121],
    737: [108],
    738: [115],
    739: [120],
    5227: [113],
    7468: [65],
    7470: [66],
    7472: [68],
    7473: [69],
    7475: [71],
    7476: [72],
    7477: [73],
    7478: [74],
    7479: [75],
    7480: [76],
    7481: [77],
    7482: [78],
    7484: [79],
    7486: [80],
    7487: [82],
    7488: [84],
    7489: [85],
    7490: [87],
    7491: [97],
    7495: [98],
    7496: [100],
    7497: [101],
    7501: [103],
    7503: [107],
    7504: [109],
    7506: [111],
    7510: [112],
    7511: [116],
    7512: [117],
    7515: [118],
    7580: [99],
    7584: [102],
    7590: [105],
    7611: [122],
    8304: [48],
    8308: [52],
    8309: [53],
    8310: [54],
    8311: [55],
    8312: [56],
    8313: [57],
    8314: [43],
    8315: [45],
    8316: [61],
    8317: [40],
    8318: [41],
    8319: [110],
    11389: [86],
  },
  cjn: {
    48: [12566],
    49: [20008],
    50: [24049],
    51: [12520],
    52: [12560],
    53: [19970],
    54: [30707],
    55: [12527],
    56: [26352],
    57: [12578],
  },
  cj1: {
    65: [20025],
    66: [20035],
    67: [21274],
    68: [20992],
    69: [12514],
    70: [19979],
    71: [12512],
    72: [21316],
    73: [24037],
    74: [20031],
    75: [12561],
    76: [12581],
    77: [29226],
    78: [21147],
    79: [21475],
    80: [12567],
    81: [21475],
    82: [23610],
    83: [12385],
    84: [21269],
    85: [12375],
    86: [12477],
    87: [23665],
    88: [13317],
    89: [12477],
    90: [20057],
  },
  cj2: {
    65: [20996],
    66: [39532],
    67: [21304],
    68: [20866],
    69: [14378],
    70: [20110],
    71: [24050],
    72: [21317],
    73: [12456],
    74: [19969],
    75: [29255],
    76: [20058],
    77: [20174],
    78: [20960],
    79: [22231],
    80: [23608],
    81: [20875],
    82: [23610],
    83: [19970],
    84: [21313],
    85: [20981],
    86: [12402],
    87: [19991],
    88: [20034],
    89: [12570],
    90: [20043],
  },
  cj3: {
    65: [21319],
    66: [12418],
    67: [20129],
    68: [38382],
    69: [20039],
    70: [20045],
    71: [24401],
    72: [24318],
    73: [24037],
    74: [20101],
    75: [12474],
    76: [12375],
    77: [20874],
    78: [20992],
    79: [21475],
    80: [25142],
    81: [46356],
    82: [23610],
    83: [19970],
    84: [19969],
    85: [45208],
    86: [5920],
    87: [23665],
    88: [20041],
    89: [65432],
    90: [20057],
  },
  che1: {
    65: [5034],
    66: [5108],
    67: [5087],
    68: [5024],
    69: [5036],
    70: [5041],
    71: [5056],
    72: [5051],
    73: [5062],
    74: [5035],
    75: [5094],
    76: [5086],
    77: [5047],
    78: [5057],
    79: [5054],
    80: [5090],
    81: [5028],
    82: [5025],
    83: [5082],
    84: [5026],
    85: [5100],
    86: [5081],
    87: [5043],
    88: [5042],
    89: [5033],
    90: [5059],
  },
  chesm1: {
    97: [43898],
    98: [5116],
    99: [43951],
    100: [43888],
    101: [43900],
    102: [43905],
    103: [5117],
    104: [43915],
    105: [43926],
    106: [43899],
    107: [43958],
    108: [43950],
    109: [43911],
    110: [43921],
    111: [43918],
    112: [43954],
    113: [43892],
    114: [43889],
    115: [43946],
    116: [43890],
    117: [43964],
    118: [43945],
    119: [43940],
    120: [43906],
    121: [43897],
    122: [43923],
  },
  canab1: {
    65: [5573],
    66: [5234],
    67: [5176],
    68: [5125],
    69: [5589],
    70: [5556],
    71: [5660],
    72: [5500],
    73: [5365],
    74: [5261],
    75: [5566],
    76: [5558],
    77: [5585],
    78: [5169],
    79: [5597],
    80: [5448],
    81: [5227],
    82: [5511],
    83: [5393],
    84: [5162],
    85: [5196],
    86: [5167],
    87: [5584],
    88: [5741],
    89: [5567],
    90: [5416],
  },
  canab2: {
    65: [5609],
    66: [5623],
    67: [5205],
    68: [5598],
    69: [5486],
    70: [5259],
    71: [5451],
    72: [5562],
    73: [5194],
    74: [5262],
    75: [5465],
    76: [5634],
    77: [5691],
    78: [5679],
    79: [5596],
    80: [5229],
    81: [5661],
    82: [5511],
    83: [5397],
    84: [5653],
    85: [5470],
    86: [5459],
    87: [5690],
    88: [5742],
    89: [5257],
    90: [5359],
  },
  canab3: {
    65: [5489],
    66: [5718],
    67: [5491],
    68: [5490],
    69: [5620],
    70: [5333],
    71: [5709],
    72: [5685],
    73: [5265],
    74: [5262],
    75: [5414],
    76: [5384],
    77: [5484],
    78: [5641],
    79: [5651],
    80: [5493],
    81: [5678],
    82: [5510],
    83: [5413],
    84: [5161],
    85: [5153],
    86: [5633],
    87: [5483],
    88: [5501],
    89: [5443],
    90: [5702],
  },
  canabsm1: {
    97: [5150],
    98: [5251],
    99: [5222],
    100: [5252],
    101: [5482],
    102: [5469],
    103: [5456],
    104: [5195],
    105: [5194],
    106: [5282],
    107: [5151],
    108: [5307],
    109: [5439],
    110: [5154],
    111: [5156],
    112: [5328],
    113: [5456],
    114: [5383],
    115: [5382],
    116: [5161],
    117: [5153],
    118: [5633],
    119: [5148],
    120: [5501],
    121: [5385],
    122: [5702],
  },
  squpto: {
    65: [7842],
    66: [385],
    67: [262],
    68: [270],
    69: [7870],
    70: [7710],
    71: [403],
    72: [42922],
    73: [7880],
    74: [308],
    75: [408],
    76: [313],
    77: [7742],
    78: [323],
    79: [416],
    80: [42836],
    81: [8506],
    82: [528],
    83: [346],
    84: [428],
    85: [431],
    86: [1140],
    87: [11378],
    88: [88, 770],
    89: [435],
    90: [381],
  },
  squpbo: {
    65: [260],
    66: [385],
    67: [199],
    68: [394],
    69: [280],
    70: [401],
    71: [290],
    72: [42922, 801],
    73: [73, 802],
    74: [42930],
    75: [310],
    76: [76, 801],
    77: [11374],
    78: [413],
    79: [490],
    80: [420],
    81: [42838],
    82: [11364],
    83: [11390],
    84: [430],
    85: [370],
    86: [7806],
    87: [11378],
    88: [1202],
    89: [435],
    90: [548],
  },
  sqlobo: {
    97: [7567],
    98: [7552],
    99: [42900],
    100: [7553],
    101: [7570],
    102: [7554],
    103: [7555],
    104: [11368],
    105: [7574],
    106: [669],
    107: [7556],
    108: [7557],
    109: [7558],
    110: [7559],
    111: [491],
    112: [7560],
    113: [587],
    114: [7561],
    115: [7562],
    116: [427],
    117: [7577],
    118: [7564],
    119: [1065],
    120: [7565],
    121: [436],
    122: [7566],
  },
  sqloto: {
    97: [7843],
    98: [595],
    99: [392],
    100: [599],
    101: [7867],
    102: [7711],
    103: [608],
    104: [614],
    105: [7881],
    106: [309],
    107: [409],
    108: [42894],
    109: [7743],
    110: [8053],
    111: [417],
    112: [421],
    113: [672],
    114: [636],
    115: [347],
    116: [357],
    117: [432],
    118: [11377],
    119: [11379],
    120: [120, 770],
    121: [436],
    122: [378],
  },
  vai1: {
    65: [42439],
    66: [42327],
    67: [42368],
    68: [42322],
    69: [42445],
    70: [42520],
    71: [42481],
    72: [42430],
    73: [42351],
    74: [646],
    75: [42467],
    76: [42822],
    77: [42350],
    78: [42406],
    79: [42462],
    80: [42525],
    81: [42346],
    82: [55297, 57189],
    83: [42359],
    84: [42401],
    85: [42425],
    86: [42524],
    87: [11378],
    88: [42505],
    89: [42247],
    90: [42345],
  },
  cun1: {
    42: [73773],
    65: [74491],
    66: [73792],
    67: [66515],
    68: [73811],
    69: [73788],
    70: [66467],
    71: [74461],
    72: [73730],
    73: [74773],
    74: [74847],
    75: [74782],
    76: [73799],
    77: [66464],
    78: [74774],
    79: [74168],
    80: [74220],
    81: [74514],
    82: [74226],
    83: [75068],
    84: [74278],
    85: [74842],
    86: [66447],
    87: [74364],
    88: [74365],
    89: [74536],
    90: [74851],
  },
  bam1: {
    65: [92645],
    66: [92659],
    67: [92496],
    68: [92583],
    69: [92194],
    70: [92712],
    71: [42730],
    72: [92569],
    73: [92515],
    74: [92695],
    75: [92297],
    76: [42714],
    77: [92305],
    78: [42712],
    79: [92501],
    80: [92270],
    81: [92520],
    82: [92586],
    83: [92698],
    84: [92327],
    85: [42678],
    86: [92261],
    87: [92617],
    88: [92646],
    89: [42674],
    90: [92393],
  },
  wdblup: {
    65: [10835],
    66: [119073],
    67: [42482],
    68: [8517],
    69: [8512],
    70: [9554],
    71: [78425],
    72: [10726],
    73: [10214],
    74: [9565],
    75: [1180],
    76: [9562],
    77: [10759],
    78: [8511],
    79: [9022],
    80: [8267],
    81: [78423],
    82: [92455],
    83: [42463],
    84: [9041],
    85: [5488],
    86: [10760],
    87: [42270],
    88: [92311],
    89: [92524],
    90: [42563],
  },
  wdbllo: {
    97: [8914],
    98: [7303],
    99: [8912],
    100: [8518],
    101: [8519],
    102: [10766],
    103: [78427],
    104: [42418],
    105: [8520],
    106: [8521],
    107: [1310],
    108: [449],
    109: [10837],
    110: [8508],
    111: [9737],
    112: [42525],
    113: [182],
    114: [8510],
    115: [120164],
    116: [9580],
    117: [8915],
    118: [10836],
    119: [42431],
    120: [10803],
    121: [8509],
    122: [7829],
  },
};
export default nmaps;
